module.exports = __webpack_public_path__ + "img/shape-ornament-01.bb5543f8.png";